/**
 * Configuration for TotalizatorSport
 */
define(function(require, exports, module) {
    'use strict';

    module.exports = {
        registrationHoldOnPopup: 'HOLD_ON',
        allowedIMSMinimalVipLevel: 5,
        loginPopupWebContentInBox: 'LOGIN-WC-AFTER-FORM',
        loginPopupWebContentOutBox: 'LOGIN-WC',
        loginPopupWebContentOutBoxLP: 'LOGIN-WC-LP',
        webcontentStickyFooterHot: 'STICKY-FOOTER-HOT',
        gamesLaunchConfiguration: {
            windowWidth: 1275,
            windowHeight: 700
        },
        pepPlayerTagName: 'portal/pep',
        depositlimits_customfield: 'custom02',
        cashier_payments_methods_commercial_names: {
            ASTROPAYviaSC: 'Astropay',
            BOLETOviaSC: 'Boleto',
            'Citadel Banking': 'Internet Banking',
            BankingPayouts: 'Internet Banking',
            CitadelViaSC: 'Internet Banking',
            EasyEFT: 'EasyEFT',
            EasyEFTviaSC: 'EasyEFT',
            'EasyEFT Payouts': 'EasyEFT',
            EasyEFTPayouts: 'EasyEFT',
            EcoCard: 'EcoPayz',
            Envoy: 'Envoy',
            EPSviaSC: 'EPS',
            GiropayViaSC: 'Giropay',
            iDebit: 'iDebit',
            IDS: 'INSTADEBIT',
            MoneyBookersViaSC: 'Skrill',
            NetellerviaSC: 'Neteller',
            PaysafecardViaSC: 'Paysafecard',
            PugglePayviaSC: 'Zimpler',
            QIWIviaSC: 'QIWI',
            SofortViaSC: 'Sofort',
            TRUSTPAYviaSC: 'TrustPay',
            WMEnvoyViaSC: 'WebMoney',
            YANDEXMONEYviaSC: 'Yandex',
            BANKTRANSFER: 'bank transfer'
        },
        cashiersPages: {
            addcardDeposit: '/payment/addcard-deposit',
            deposit: '/payment/deposit',
            withdraw: '/payment/withdraw',
            pendingWithdraw: '/pending-withdraw',
            transactionHistory: '/transaction-history',
            promoCode: '/promo-code',
            bonusHistory: '/bonus-history',
            referFriend: '/refer-a-friend',
            changePassword: '/change-password',
            updateMyDetails: '/update-my-details',
            responsibleGaming: '/responsible-gaming',
            contactPreferences: '/contact-preferences',
            addCard: '/payment/addcard',
            balance: '/balance',
            loyaltyPoints: '/loyalty-points',
            verificare: '/verification',
            promotions: '/promotions'
        },
        transactionDirectionDesc: true,
        registrationPlayerTagName: 'portal/source_of_funds',
        registrationPlayerTagValue: 'test/testUserTag1',
        cashierDefaultHeight: '640',
        returnBlockedPaymentMethods: false,
        promotionsPageURL: '/promocje',
        gameCashiersPages: {
            addcardDeposit: '/game/payment/addcard-deposit',
            addCard: '/game/payment/addcard',
            deposit: '/game/payment/deposit',
            withdraw: '/game/payment/withdraw',
            pendingWithdraw: '/game/pending-withdraw',
            transactionHistory: '/game/transaction-history',
            promoCode: '/game/promo-code',
            bonusHistory: '/game/bonus-history',
            balance: '/game/balance',
            loyaltyPoints: '/game/loyalty-points',
            referFriend: '/game/refer-a-friend',
            changePassword: '/game/change-password',
            updateMyDetails: '/game/update-my-details',
            verificare: '/game/verification',
            responsibleGaming: '/game/responsible-gaming',
            contactPreferences: '/game/contact-preferences'
        },
        loginPageUrl: '/login',
        tilesCustomCssValues: {
            'default': {
                cellWidth: 24.25,
                cellHeight: 19.5,
                cellMarginL: 0.5,
                cellMarginR: 0.5,
                cellMarginT: 0,
                cellMarginB: 2,
                containerPaddingL: 0.25,
                containerPaddingR: 0.25,
                containerPaddingT: 1
            },
            casino: {
                cellWidth: 24.25,
                cellHeight: 24.25,
                cellMarginL: 1,
                cellMarginR: 1,
                cellMarginT: 0,
                cellMarginB: 2,
                containerPaddingL: 0.25,
                containerPaddingR: 0.25,
                containerPaddingT: 1
            },
            casinoMobile: {
                cellWidth: 24.25,
                cellHeight: 24.25,
                cellMarginL: 0.5,
                cellMarginR: 0.5,
                cellMarginT: 0,
                cellMarginB: 1,
                containerPaddingL: 0.25,
                containerPaddingR: 0.25,
                containerPaddingT: 1
            },
            slots: {
                cellWidth: 24.25,
                cellHeight: 14.25,
                cellMarginL: 1,
                cellMarginR: 1,
                cellMarginT: 0,
                cellMarginB: 2,
                containerPaddingL: 0.25,
                containerPaddingR: 0.25,
                containerPaddingT: 1
            }
        },
        gamesTilesLayoutsCustomConfig: [
            {
                name: 'Casino Mobile',
                useScrollingRow: true,
                showItemsInScrollingRow: {
                    top: 2.7,
                    left: 4.7
                },
                useLayoutsDependentOnOrientation: true
            },
            {
                name: 'Slots Mobile',
                useLayoutsDependentOnOrientation: true
            },
            {
                name: 'Slots Tablet',
                useLayoutsDependentOnOrientation: true
            },
            {
                name: 'Slots Mobile 1x1',
                useLayoutsDependentOnOrientation: true
            },
            {
                name: 'Casino Mobile Without Scroll',
                useLayoutsDependentOnOrientation: true
            },
            {
                name: 'Casino Tablet Without Scroll',
                useLayoutsDependentOnOrientation: true
            }
        ],
        gamesSliderConfig: {
            useCustomPagination: true,
            useLazyLoading: true
        },
        sourceoffunds_customfield: 'custom20',
        privateBankingPlayerTagName: 'portal/private_banking',
        ibanPrefix: 'pl',
        isIbanInUserData: true,
        sofOptions: [
            'playtech.mobile.update-my-details.sof.contract',
            'playtech.mobile.update-my-details.sof.handicapped',
            'playtech.mobile.update-my-details.sof.offer',
            'playtech.mobile.update-my-details.sof.volunteer',
            'playtech.mobile.update-my-details.sof.donate',
            'playtech.mobile.update-my-details.sof.win',
            'playtech.mobile.update-my-details.sof.activity'
        ]
    };
});
